import { createFileRoute } from "@tanstack/react-router";

import { DueDatePageView } from "../components/tools/due-date";
import { faqJsonLd } from "../components/tools/tool-layout";
import { DUE_DATE_PAGES } from "../lib/due-date-pages";
import { seo } from "../lib/head";

const page = DUE_DATE_PAGES.lmp;

export const Route = createFileRoute("/calcul-date-accouchement/")({
  staticData: { ssr: true },
  head: () =>
    seo({ title: page.title, description: page.description, jsonLd: faqJsonLd(page.faq) }),
  component: () => <DueDatePageView page={page} />,
});
